<template>
  <div class="pager">
    <!-- 平台备注弹窗 -->
    <el-dialog title="备注详情" :visible.sync="noteVisible" width="450">
      <div style="white-space:pre-wrap;">{{ currentNote || "" }}</div>
      <div slot="footer">
        <el-button @click="noteVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <div class="addbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="addRom">添加</el-button>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <el-select v-model="queryParams.romType" placeholder="请选择rom类型">
            <el-option v-for="item in getDictDatas(DICT_TYPE.ROM_TYPE)" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="queryParams.romGameType" placeholder="请选择rom游戏类型">
            <el-option v-for="item in getDictDatas(DICT_TYPE.ROM_GAME_TYPE)" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <p>名字：</p>
          <el-input v-model="queryParams.romName" placeholder="请输入名字" clearable></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-popconfirm icon="el-icon-info" icon-color="red" title="确认删除选中的rom吗？" popper-class="customerdel-popover"
            @confirm="deleteFn()">
            <el-button slot="reference" icon="el-icon-delete" class="add-btn" style="margin-right: 10px">删除</el-button>
          </el-popconfirm>
          <el-button type="primary" icon="el-icon-refresh-right" class="reset-btn" @click="resetFn">重置</el-button>
          <el-button type="primary" icon="el-icon-search" class="search-btn" @click="search">查询</el-button>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" tooltip-effect="dark" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }" show-overflow-tooltip @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="romIcon" label="rom图标">
          <template slot-scope="{ row }">
            <div class="logo">
              <el-image :src="row.romIcon" :preview-src-list="[row.romIcon]" fit="cover" style="width: 55%" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="romName" label="名字(中文)" min-width="120">
        </el-table-column>

        <el-table-column prop="romNameEn" label="名字(英文)" min-width="120">
        </el-table-column>

        <el-table-column prop="romType_dictText" label="rom类型" min-width="60">
        </el-table-column>

        <el-table-column prop="romGameType_dictText" label="游戏类型" min-width="60">
        </el-table-column>


        <el-table-column label="支持平台" min-width="160">
          <template slot-scope="scope">
            <span v-if="!scope.row.romPlatformListRes || scope.row.romPlatformListRes.length === 0">暂无</span>
            <template v-else>
              <div v-for="(platformItem, index) in scope.row.romPlatformListRes" :key="index"
                style="display:inline-block;margin-right:4px;cursor:pointer;" @click="openNote(platformItem)">
                <el-tag size="mini"
                  :type="platformItem.status === 1 || platformItem.notes === '待核验' ? 'danger' : 'success'"
                  style="margin-right:4px;">
                  {{ platformItem.romSupportedPlatform_dictText }}
                </el-tag>
              </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button class="textOrange-btn" @click="goEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > queryParams.pageSize" :total="total" :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize" @pagination="init" />
    </div>
  </div>
</template>

<script>
import { getRomsList, editRomStatus, deleteRoms } from "@/api/simulator";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        romType: "",
        romGameType: "",
        romName: "",
      },
      tableData: [],
      total: 0, //总数
      selectList: [],
      romSupportedPlatformList: [],
      noteVisible: false,
      currentNote: ""
    };
  },
  async created() {
    const backPage = Number(this.$route.query.page);
    if (backPage && backPage > 0) {
      this.queryParams.pageNum = backPage;
    }

    this.init();
  },
  mounted() {
  },
  methods: {
    //获取roms列表
    async init() {
      const res = await getRomsList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;

      const maxPage = Math.ceil(this.total / this.queryParams.pageSize) || 1;
      if (this.queryParams.pageNum > maxPage) {
        this.queryParams.pageNum = maxPage;
        this.init();
      }
    },

    // 打开备注
    openNote(item) {
      this.currentNote = item.notes;
      this.noteVisible = true;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.romType = "";
      this.queryParams.romGameType = "";
      this.queryParams.romName = "";
      // this.queryParams.pageNum = 1;
      this.init();
    },
    // 去添加
    addRom() {
      this.$router.push({
        path: "/addRom",
        query: {
          type: "add",
          page: this.queryParams.pageNum
        },
      });
    },
    // 去修改
    goEdit(item) {
      this.$router.push({
        path: "/addRom",
        query: {
          type: "edit",
          id: item.id,
          page: this.queryParams.pageNum
        },
      });
    },
    //修改rom状态
    async cancelOrder(item, status) {
      const params = {
        status,
        id: item.id,
      };
      await editRomStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的rom");
        return;
      }
      await deleteRoms(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pager {
  position: relative;

  .addbox {
    position: absolute;
    top: -88px;
    right: 0;
  }

  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;

    ::v-deep .querybox {
      display: flex;
      align-items: center;

      >div {
        display: flex;
        align-items: center;
        margin-right: 24px;

        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }

        .el-input,
        .el-range-editor {
          width: 216px;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }

        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }

    .handlebox {
      display: flex;
      align-items: center;
    }
  }

  .content {
    .logo {
      display: flex;
      justify-content: center;
      border-radius: 10px;

      img {
        width: 60%;
        border-radius: 4px;
      }

    }

    .textOrange-btn {
      margin: 0 10px;
    }

    ::v-deep .is-checked {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }

    ::v-deep .is-indeterminate {
      .el-checkbox__inner {
        background-color: #ff5d2f;
        border-color: #ff5d2f;
      }
    }

    ::v-deep .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
